import jp from "jsonpath";

/**
 * js-filter
 * @param {*} param
 * @returns
 */
export function filter({ input, filterExpr }) {
  return jp.query(input, `$[?(${filterExpr})]`)
}

/**
 * 遍历目标对象，使用jsonPath进行替换
 * @param {*} item 元数据
 * @param {*} obj 目标对象
 */
function mapJsonPath(item, obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (typeof value === 'string') {
        if (value.indexOf("$.") > -1) {
          obj[key] = jp.query(item, value);
        } else {
          obj[key] = item[value];
        }
        continue;
      }
      if (Array.isArray(value)) {
        continue;
      }
      if (typeof value === 'object') {
        mapJsonPath(item, value);
        continue;
      }
    }
  }
}

/**
 * js-map
 * @param {*} param
 * @returns
 */
export function map({ input, output, type }) {
  return input.map(item => {
    let newOutput = JSON.parse(JSON.stringify(output)); // 深拷贝
    mapJsonPath(item, newOutput);
    if (type === "increment") {
      return Object.assign(item, newOutput);
    } else {
      return newOutput;
    }
  });
}

/**
 * js-reduce
 * @param {*} param
 * @returns
 */
export function reduce({ input, target, type }) {
  if (type === "avg") {
    const sum = input.reduce((pre, cur) => {
      const resolvedCur = cur instanceof Object ? jp.query(cur, target) : cur;
      return pre + Number(resolvedCur);
    }, 0);
    return sum / input.length;
  }
  if (type === "sum") {
    return input.reduce((pre, cur) => {
      const resolvedCur = cur instanceof Object ? jp.query(cur, target) : cur;
      return pre + Number(resolvedCur);
    }, 0);
  }
  if (type === "join") {
    return input.reduce((pre, cur) => {
      const resolvedCur = cur instanceof Object ? jp.query(cur, target) : cur;
      return pre.concat(resolvedCur);
    }, "");
  }
}

/**
 * js-array2tree
 * @param {*} param
 * @returns
 */
export function array2tree({ arr, key, parentColumn, childrenColumn }) {
  let map = {}, node, roots = [];

  for (let i = 0; i < arr.length; i++) {
    map[arr[i][key]] = i;
    arr[i][childrenColumn] = [];
  }

  for (let i = 0; i < arr.length; i++) {
    node = arr[i];
    if (node[parentColumn]) {
      if (typeof arr[map[node[parentColumn]]] === 'undefined') {
        console.log(`找不到数组中的：`, map[node[parentColumn]], parentColumn);
        continue;
      }
      arr[map[node[parentColumn]]][childrenColumn].push(node);
    } else {
      roots.push(node);
    }
  }
  return roots;
}